export default __webpack_public_path__ + "static/media/info.1f3492fd.svg";